import { Element as SlateElement, Text, } from 'slate';
import { jsx } from 'slate-hyperscript';
import { EmptyDocument } from './editorUtils';
/**
 * Convert a Html string into the format required for our implementation of
 * slate.js
 *
 * @param html
 */
export function deserializeFromHtml(html) {
    if (!html || html.trim().length === 0) {
        return EmptyDocument;
    }
    const document = new DOMParser().parseFromString(html, 'text/html');
    // Deal with plan text, which only has one node
    if (document.body.childNodes.length === 1 &&
        document.body.childNodes[0].nodeType === Node.TEXT_NODE) {
        const textContent = document.body.childNodes[0].textContent;
        if (textContent) {
            return textContent.split('\n').map((text) => ({
                type: 'paragraph',
                children: [{ text }],
            }));
        }
    }
    const nodes = deserialize(document.body); // Top level is always an array.
    nodes.forEach((node) => normalize(node));
    return nodes;
}
/**
 * Makes sure the node conforms to slates requirements Note this does mutate the
 * node
 */
const normalize = (node) => {
    if (Text.isText(node)) {
        return;
    }
    // Ensure that block and inline nodes have at least one text child.
    if (SlateElement.isElement(node) && node.children.length === 0) {
        node.children.push({ text: '' });
        return;
    }
};
/**
 * Converts a Dom node into a Slate.js node where the Node types make what we
 * allow
 *
 * @param el Dom node
 * @returns A slate.js Node
 */
function deserialize(el) {
    if (el.nodeType === 3) {
        return el.textContent;
    }
    if (el.nodeType !== 1) {
        return null;
    }
    let children = Array.from(el.childNodes).map(deserialize).flat();
    if (children.length === 0) {
        children = [{ text: '' }];
    }
    switch (el.nodeName) {
        case 'BODY':
            return jsx('fragment', {}, children);
        case 'BR':
            return '\n';
        // H2 only valid heading type, but just in case...
        case 'H1':
        case 'H2':
        case 'H3':
            return jsx('element', { type: 'heading-two' }, children);
        case 'P':
            return jsx('element', { type: 'paragraph' }, children);
        case 'IMG':
            return jsx('element', { type: 'image', src: el.getAttribute('src') }, children);
        case 'A':
            return jsx('element', { type: 'link', href: el.getAttribute('href') }, children);
        case 'STRONG':
            return jsx('text', { bold: true }, children);
        case 'EM':
            return jsx('text', { italic: true }, children);
        case 'U':
            return jsx('text', { underline: true }, children);
        default:
            return el.textContent;
    }
}
